import {
    robotoRegular,
    scarpaGray100,
    scarpaGray400,
    scarpaGray800,
    spanishViridian500,
    white,
} from "@habitech/shared";
import styled from 'styled-components';

export const Card = styled.div`
    background-color: ${white};
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(48, 49, 51, 0.08);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .header-title {
        margin: 0;
        font-family: ${robotoRegular};
        font-size: 16px;
        font-weight: 700;
        color: ${spanishViridian500};
        display: flex;
        align-items: center;
        gap: 8px;
    }
`;

export const PeriodChip = styled.span`
    font-family: ${robotoRegular};
    font-size: 12px;
    font-weight: 500;
    color: #8B6914;
    background-color: #FDFBF6;
    padding: 4px 10px;
    border-radius: 999px;
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 0;
    gap: 8px;
    color: ${scarpaGray400};
    font-family: ${robotoRegular};
    font-size: 14px;
`;

export const ProductList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ProductRow = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${scarpaGray800};

    .product-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
    .product-name {
        margin: 0;
    }
    .product-quantity {
        margin: 0;
        font-size: 12px;
        color: ${scarpaGray400};
    }
    .product-price {
        font-weight: 700;
        margin: 0;
    }
    .remove-btn {
        padding: 4px;
        border: none;
        background: none;
        cursor: pointer;
        color: ${scarpaGray400};
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
            color: ${scarpaGray800};
        }
    }
`;

export const Divider = styled.hr`
    border: none;
    border-top: 1px solid ${scarpaGray100};
    margin: 0;
`;

export const TotalRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 700;
    color: ${spanishViridian500};

    .total-label {
        margin: 0;
    }
    .total-amount {
        margin: 0;
    }
`;

export const PaymentRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${scarpaGray800};

    .payment-label {
        margin: 0;
        display: flex;
        align-items: center;
        gap: 6px;
        color: ${scarpaGray800};
    }
    .payment-value {
        margin: 0;
        font-weight: 700;
    }
`;

export const CheckboxRow = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    font-family: ${robotoRegular};
    font-size: 13px;
    color: ${scarpaGray800};
    margin: 0;

    input {
        margin-top: 2px;
        accent-color: ${spanishViridian500};
        width: 18px;
        height: 18px;
        flex-shrink: 0;
    }
`;

